/**
 * URL route constants for the App Updates application
 */

export const ROUTES = {
  /**
   * Base route for the app updates list page (the "All changes" tab)
   */
  RELEASE_NOTES: '/release-notes',

  /**
   * Route for the app updates list page with the "Bundled changes" tab active
   */
  RELEASE_TRACKS_CHANGES: '/release-notes/bundled-changes',

  /**
   * Route for app update details page
   * @param id - The update ID
   * @returns The complete route path
   */
  RELEASE_NOTE_DETAILS: (id: string) => `/release-notes/${id}`,
} as const;
